/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import Colors from "themes/themeColors";
import Arrow from "components/elements/Arrow";
import { DebounceInput } from "react-debounce-input";
import themeColors from "themes/themeColors";

interface Props {
  id?: string;
  handleChange: (select: string) => void;
  list: { name: string; id: any; icon?: any }[];
  selection: string;
  title: string;
  defaultOption?: any;
  width?: string;
  isMuti?: Boolean;
  height?: number;
  value?: string | number;
  selectAllOption?: boolean;
  styleActive?: boolean;
  disabled?: boolean;
  selectText?: boolean;
  type?: string;
  preview?: boolean;
  returnId?: boolean;
  haveIcon?: boolean;
  errorMessage?: string;
  haveSearch?: boolean;
  handleSearch?: (data: any) => void;
  placeholderSearch?: string;
  handleItem?: (title: string) => void;
}

const GenericDropdownWithId = ({
  id = "select-object",
  handleChange,
  list,
  selection,
  title,
  disabled,
  defaultOption,
  width = "max-content",
  isMuti = true,
  height = 56,
  styleActive = true,
  value,
  selectAllOption = false,
  selectText = true,
  type = "basePolicy",
  preview = false,
  returnId = true,
  haveIcon = false,
  errorMessage = null,
  haveSearch,
  handleSearch,
  placeholderSearch,
  handleItem = () => {}
}: Props) => {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [active, setActive] = useState<any>(defaultOption);
  const [localName, setLocalName] = useState<string | number>();
  const [localIcon, setLocalIcon] = useState(null);
  const [searchVal, setSearchVal] = useState<string>("");

  useEffect(() => {
    if (list && list.length > 0) {
      const findName = list?.find((el) => el.id === value);
      setLocalName(findName?.name);
      setLocalIcon(findName?.icon);
      return;
    }
    setLocalName(null);
    setLocalIcon(null);
    // if (active) {
    //   const findName = list.find((el) => el.id === active);
    //   setLocalName(findName.name);
    // }
  }, [value, active, list]);

  useEffect(() => {
    setActive(selection);
  }, [selection]);

  const handleSelectItem = (select: string) => {
    setActive(select);
    handleChange(select);
  };

  const handleReloadItem = (title) => {
    handleItem(title);
    setSearchVal("");
  };

  const renderItem = (item: any, active: any) => {
    return (
      <DropdownItemStyle
        key={item.id}
        onClick={() => {
          if (returnId) {
            handleSelectItem(item.id);
          } else {
            handleSelectItem(item.name);
          }
        }}
        style={{
          height: "48px",
          borderBottom: "1px solid #e4e4e4 !important",
          margin: "0 !important",
        }}
      >
        {active === item.id ? (
          <div
            style={{
              color: Colors.Gray333,
              fontWeight: styleActive ? 600 : 400,
              display: "flex",
              gap: 5,
              alignItems: "center",
            }}
          >
            {haveIcon && item.icon}
            {t(item.name)}
          </div>
        ) : (
          <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
            {haveIcon && item.icon}
            {t(item.name)}
          </div>
        )}
      </DropdownItemStyle>
    );
  };

  /* eslint-disable */
  const dropDown = () => {
    return (
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        style={{
          // border:
          //   active === null
          //     ? `1px solid ${Colors.Gray999}`
          //     : active !== defaultOption
          //     ? `1px solid ${Colors.Primary}`
          //     : `1px solid ${Colors.Gray999}`,
          border: errorMessage
            ? `1px solid ${Colors.Error}`
            : disabled ? "1px solid #C0C9D5" :active
            ? `1px solid ${Colors.Primary}`
            : `1px solid ${Colors.Gray999}`,
          height,
          borderRadius: "8px",
          background: disabled ? "#E7E9ED" : "#fff",
          width,
          display: "flex",
          alignContent: "space-between",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        disabled={disabled}
      >
        <DropdownToggleStyle
          id={`${id}-dropdown-toggle`}
          color="x"
          style={{
            width,
            display: "flex",
            alignContent: "space-between",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 10,
            // color: active !== defaultOption ? 'rgba(40, 50, 55, 1)' : '#999999',
            color: active ? `${Colors.Gray333}` : `${Colors.Gray999}`,
            // color: active ? "rgba(40, 50, 55, 1)" : "#999999",
          }}
          onClick={() => {
            handleReloadItem(title);
          }}
        >
          <span style={{ display: "flex", gap: 5, alignItems: "center" }}>
            {haveIcon && localIcon}
            {t(
              localName ||
                (active === 0 ? "0" : active) ||
                `${selectText ? `Select ${title}` : title}`
            )}
          </span>
          {/* <span>{t(localName || active || `${selectText ? `Select ${title}` : title}`)}</span> */}
          <Arrow border={2} length={9} color="#666666" rotate={45} />{" "}
        </DropdownToggleStyle>
        <DropdownMenu
          className="mt-3"
          style={{
            borderRadius: 8,
            width,
            minWidth: "100%",
            maxHeight: "300px",
            border: `1px solid ${Colors.Gray999}`,
            padding: "0",
            overflow: "scroll",
          }}
        >
          {haveSearch && (
            <WrapSearch>
              <DebounceInput
                debounceTimeout={1000}
                onChange={(event) => {
                  handleSearch(event.target.value);
                  setSearchVal(event.target.value);
                }}
                style={{ height: "56px", borderRadius: "8px" }}
                placeholder={placeholderSearch}
                className="form-control"
                value={searchVal || ""}
              />
            </WrapSearch>
          )}
          {isMuti === true ?? (
            <DropdownItemStyle
              key="all"
              onClick={() => {
                handleSelectItem(defaultOption);
              }}
            >
              {`All ${title}`}
            </DropdownItemStyle>
          )}
          {list?.length > 0 &&
            list?.map((item: any) => renderItem(item, active))}
        </DropdownMenu>
      </Dropdown>
    );
  };

  return preview ? (
    <Title>
      {t(localName || active || `${selectText ? `Select ${title}` : title}`)}
    </Title>
  ) : (
    dropDown()
  );
};

export const DropdownItemStyle = styled(DropdownItem)`
  white-space: pre-wrap;
  &.active {
    background: #ffcc4d;
  }
  font-weight: 400;
  && {
    min-width: 10rem;
  }
  &:hover {
    && {
      font-weight: 400;
    }
  }
`;

export const DropdownToggleStyle = styled(DropdownToggle).attrs(({ id }) => ({
  id,
}))`
  &.btn {
    color: #263238;
    font-size: 16px;
    font-weight: 400;
    &:hover,
    &:focus,
    &:visited {
      text-decoration: none;
    }
  }
`;

const WrapSearch = styled.div`
	width: 100%;
	height: 88px;
	padding: 16px 24px 16px 24px;
	background-color: ${themeColors.Gray111};
	position: relative;
	display: flex;
	align-items: center;
	margin: 0;
	&:before {
		background: url(${process.env.PUBLIC_URL}/images/search.png) no-repeat center
			left;
		content: "";
		display: block;
		clear: both;
		width: 20px;
		height: 20px;
		position: absolute;
		top: 34px;
		left: 30px;
	}
	input.form-control {
		padding-left: 30px;
	}
`;

const Title = styled.p`
  font-size: 14;
  font-weight: 700;
  color: #333333;
`;

export default GenericDropdownWithId;
